module.exports = __webpack_public_path__ + "media/images/logo_alizza-9122ce75a983883a973dde99f94f0cf6.png";